module.exports = __webpack_public_path__ + "img/peixun.0a1b7417.png";